/**
 * Image Placeholder Handler
 * Extracts first letter from titles for image placeholders
 */

function initializePlaceholders() {
    // Handle all types of placeholders
    const placeholderSelectors = [
        '.first-letter-placeholder',
        '.page-first-letter-placeholder', 
        '.card-first-letter-placeholder'
    ];
    
    placeholderSelectors.forEach(selector => {
        const placeholders = document.querySelectorAll(selector);
        placeholders.forEach(placeholder => {
            const title = placeholder.getAttribute('data-title');
            if (title && title.length > 0) {
                // Extract first letter and make it uppercase
                const firstLetter = title.charAt(0).toUpperCase();
                placeholder.textContent = firstLetter;
            }
        });
    });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializePlaceholders);

// Also initialize on dynamic content changes (for infinite scroll, etc.)
if (typeof window !== 'undefined') {
    window.initializePlaceholders = initializePlaceholders;
} 